var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 69.902,
    viewBox: "0 0 98 69.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e6e6eb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0V69.9H98V0ZM12.25,8.738h73.5V34.951L73.5,26.213,61.25,34.951l24.5,17.476v8.738H73.5l-49-34.951L12.25,34.951Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/defaultImg.44356e83876c83fcc5004a94f5d13e56.svg";
export { ForwardRef as ReactComponent };